import React, { useEffect } from "react";
import { setAlert } from "action";
import { loadScript } from "util/loadScript";
import LaLogo from "../../../assets/images/la-logo.png";
import API from "api";
import {useDispatch, useSelector } from "react-redux";
import { refreshUserSubscriptions } from "util/refreshUserSubscriptions";

const RazorPay = ({
  plan,
  children,
  isLoggedIn = true,
  redirect,
  activeTab,
  setLoading
}) => {
  const { id: planId } = plan;
  const dispatch = useDispatch();

  const userData = useSelector((state) => {
    const user = state.user;
    if (!user) {
      return {};
    }
    let data = { email: user.email };
    ifThere(["phone", "first_name"], data, user);
    return data;
  });

  function ifThere(keys, data, main) {
    keys.forEach((key) => {
      main[key] && (data[key] = main[key]);
    });
  }

  // console.log(userData);
  useEffect(() => {
    async function init() {
      // console.log("ran");
      const res = await loadScript(
        "https://checkout.razorpay.com/v1/checkout.js",
        "razorpay-script"
      );

      if (!res) {
        alert("Something went wrong. Please try again later");
        return;
      }
    }
    init();
  }, []);

  async function displayRazorpay() {
    try {
       setLoading(true)
      let url = "createSubscription";
      if (!isLoggedIn) {
        url = "createSubscriptionWithoutLogin";
      }
      console.log({ package_id: planId });
      const response = await API({
        method: "POST",
        url,
        data: { package_id: planId, platform: activeTab },
      });

      if (response.status != 200) {
        return alert("Something went wrong. " + response.message);
      }
        setLoading(false)
      const { subscriptionData } = response.data;
      const { id: subId } = subscriptionData;

      const options = {
        key: import.meta.env.VITE_RAZORPAY_PUBLIC_KEY,
        subscription_id: subId,
        name: "Language Academy",
        description: "Monthly Silver Plan",
        image: LaLogo,
        handler: afterPayment,
        prefill: userData,
        theme: {
          color: "#F37254",
        },
        config: {
          display: {
            hide: [
              {
                method: "card",
              },
            ],
            preferences: {
              show_default_blocks: true,
            },
          },
        },
      };
      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
    } catch (error) {
      setLoading(false)
      dispatch(
      setAlert({ flag: true, type: 2, message: "Something went wrong." })
      );
    }
  }

  async function afterPayment({
    razorpay_payment_id,
    razorpay_subscription_id,
    razorpay_signature,
  }) {
    setLoading(true);
    const data = {
      razorpay_payment_id,
      razorpay_signature,
      razorpay_subscription_id,
      plan_id: planId,
    };

    let url = "verifySignature";
    if (!isLoggedIn) {
      url = "verifySignatureWithoutLogin";
    }

    try {
      const resp = await API({
        method: "POST",
        url,
        data,
      });

        // console.log(resp);
      if (resp.status == 200) {
        await refreshUserSubscriptions(dispatch);
        return redirect();
      }

      alert(
        "Something went wrong. Invalid payment signature. Please contact us regarding this issue"
      );
    } finally {
      setLoading(false);
    }
  }

  return children(displayRazorpay);
};

export default RazorPay;
